"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachAssignationToPassengers = attachAssignationToPassengers;
exports.setAssignationIdForPassengers = setAssignationIdForPassengers;
const lodash_1 = require("lodash");
const mapPassengersToVehicles_1 = require("./mapPassengersToVehicles");
function attachAssignationToPassengers({ passengers, vehicles, assignation, activeAssignations, }) {
    const vehiclesConfig = (0, mapPassengersToVehicles_1.mapPassengersToVehicles)({ passengers, vehicles });
    const config = vehiclesConfig[assignation.vehicleIndex];
    const configHasOtherAssignations = config.passengers.map((p) => p.assignationId).filter((id) => Boolean(id));
    if (configHasOtherAssignations.length > 0) {
        adjustAssignationsToConfig(vehiclesConfig, passengers, [...activeAssignations, assignation]);
    }
    else {
        config.passengers.forEach((passenger) => {
            passenger.assignationId = assignation._id;
        });
    }
}
function passengersComparator(a, b) {
    if (a.luggage && b.luggage && a.type && b.type) {
        return (0, lodash_1.isEqual)(a.luggage, b.luggage) && a.type === b.type && a.childSeatType === b.childSeatType;
    }
}
function setAssignationIdForPassengers({ oldPassengers, newPassengers, oldVehicles, newVehicles, assignations, }) {
    const oldVehiclesConfig = (0, mapPassengersToVehicles_1.mapPassengersToVehicles)({ passengers: oldPassengers, vehicles: oldVehicles });
    const newVehiclesConfig = (0, mapPassengersToVehicles_1.mapPassengersToVehicles)({ passengers: newPassengers, vehicles: newVehicles });
    const noAssignationsToNotify = (0, lodash_1.isEqualWith)(oldPassengers, newPassengers, passengersComparator) && (0, lodash_1.isEqual)(oldVehicles, newVehicles);
    const assignationsToNotify = noAssignationsToNotify ? [] : (0, lodash_1.uniq)(getAssignationsToNotify(oldVehiclesConfig, newVehiclesConfig));
    adjustAssignationsToConfig(newVehiclesConfig, newPassengers, assignations);
    return assignationsToNotify;
}
function adjustAssignationsToConfig(newVehiclesConfig, newPassengers, assignations) {
    newPassengers.forEach((passenger) => {
        if (passenger.assignationId) {
            passenger.assignationId = null;
        }
    });
    assignations.forEach((assignation) => {
        const config = newVehiclesConfig[assignation.vehicleIndex];
        if (config) {
            config.passengers.forEach((passenger) => {
                passenger.assignationId = assignation._id;
            });
        }
    });
}
function getAssignationsToNotify(oldVehicles, newVehicles) {
    // if vehicles count changed, we assume all remaining assigned drivers should be notified
    if (oldVehicles.length !== newVehicles.length) {
        return oldVehicles.reduce((acc, ov) => (ov.passengers[0]?.assignationId ? [...acc, ov.passengers[0]?.assignationId] : acc), []);
    }
    return oldVehicles.reduce((acc, ovc, index) => {
        const assignationId = ovc.passengers[0]?.assignationId;
        if (!assignationId) {
            return acc;
        }
        const nvc = newVehicles[index];
        if (!nvc) {
            acc.push(assignationId);
            return acc;
        }
        // don't check particular passengers changes, only quantities
        if (!(0, lodash_1.isEqual)((0, lodash_1.omit)(nvc, ["passengers"]), (0, lodash_1.omit)(ovc, ["passengers"]))) {
            acc.push(assignationId);
        }
        return acc;
    }, []);
}
//# sourceMappingURL=setAssignationIdForPassengers.js.map